import { libelleOrigine } from "../utils/format";

export function OrigineBadge({ origine }: { origine: string }) {
  const classe =
    origine === "VERIFIEE_TICKBOSS"
      ? "origine origine--verifiee"
      : origine === "IMPORTEE_LIVE"
        ? "origine origine--live"
        : "origine";
  return (
    <span className={classe} title="Origine de cette donnée">
      <span aria-hidden="true">●</span>
      {libelleOrigine(origine)}
    </span>
  );
}
